
<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'brutto'" i18n>inkl. MwSt.</ng-container>
  <ng-container *ngSwitchCase="'netto'" i18n>exkl. MwSt.</ng-container>
  <ng-container *ngSwitchCase="'neutral'"></ng-container>
</ng-container>
